import Modal from '../../components/Modal'
import ModalContent from '../../components/Modal/modal-content'
import styled from 'styled-components'
import { ReceiveButton } from '../../components/Button'
import { PoolInfo } from '../../hooks/usePoolInfo'
import { ReleaseSection } from '../../hooks/useClaimSection'
import moment from 'moment'
import { formatUnits } from 'ethers/lib/utils'
import useIGOClaim from '../../hooks/useIGOClaim'
import { BigNumber } from 'ethers'

export default function RecordModal(props: {
  poolInfo: PoolInfo
  show: boolean
  onClose: () => void
  claimInfo: { sections: ReleaseSection[]; claimedAmount: BigNumber }
}) {
  const { sections, claimedAmount } = props.claimInfo
  const { handleClaim } = useIGOClaim(props.poolInfo.address)
  return (
    <Modal open={props.show} onClose={props.onClose}>
      <StyledModalContent onClose={props.onClose}>
        <Title>Shares Claim History</Title>
        <Subtitle>
          Shares claimed:
          <span>
            {formatUnits(claimedAmount, props.poolInfo.targetToken.decimals)} {props.poolInfo.targetToken.symbol}
          </span>
        </Subtitle>
        <Table>
          <Thead>
            <span>Time(UTC)</span>
            <span>Term</span>
            <span>Token</span>
            <span>Status</span>
          </Thead>
          <Tbody>
            {sections.map((section, index) => (
              <li key={index}>
                <span>{moment.unix(section.time).utc().format('YYYY.MM.DD hh:mma')}</span>
                <span>Term {index + 1}</span>
                <span>
                  {+formatUnits(section.amount, props.poolInfo.targetToken.decimals)}{' '}
                  {props.poolInfo.targetToken.symbol}
                </span>
                <span>
                  <ReceiveButton onClick={handleClaim} disabled={section.claimed || !section.canClaim}>
                    {section.claimed ? 'Claimed' : section.canClaim ? 'Claim' : 'Upcoming'}
                  </ReceiveButton>
                </span>
              </li>
            ))}
          </Tbody>
        </Table>
      </StyledModalContent>
    </Modal>
  )
}

const StyledModalContent = styled(ModalContent)`
  width: 710px;
  height: 566px;
  background: #fff;
  padding: 29px 27px 0 27px;
`

const Title = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  line-height: 33px;
  text-align: center;
`
const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #323651;
  line-height: 20px;
  text-align: center;
  margin-top: 12px;
  span {
    color: #ffa522;
  }
`

const Table = styled.div`
  width: 658px;
  height: 412px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #dadada;
  position: relative;
  margin-top: 26px;
  overflow: hidden;
`

const Thead = styled.div`
  width: 100%;
  height: 52px;
  border-bottom: solid 1px #dbdbdb;
  display: grid;
  padding-left: 22px;
  grid-template-columns: 150px 142px 167px 160px;
  justify-items: start;
  align-items: center;
  span {
    font-weight: 600;
    color: #000000;
    line-height: 20px;
    font-size: 14px;
  }
`
const Tbody = styled.ul`
  height: 361px;
  width: 100%;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 6px;
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #dcdcdc;
    position: relative;
    left: -50px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 2px;
    background: transparent;
  }
  li {
    display: grid;
    padding-left: 22px;
    grid-template-columns: 150px 142px 167px 160px;
    justify-items: start;
    align-items: center;
    height: 50px;
    &:nth-child(even) {
      background: #f8f8f8;
    }

    span {
      font-weight: normal;
      color: #000000;
      line-height: 16px;
      font-size: 14px;
    }
  }
`
